import type { JobAdsState } from "@/modules/jobAds/client/api/types"

import { useQuery } from "@tanstack/react-query"

import { JOB_ADS_STATE_QUERY_KEY } from "@/modules/jobAds/client/api/constants"
import { getJobAdsState } from "@/modules/jobAds/client/api/getJobAdsState"
import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/jobAds/client/constants"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

type JobAdsStateFetch = {
  jobAdsState?: JobAdsState
  isLoadingJobAdsState: boolean
  isSuccessJobAdsState: boolean
  isErrorJobAdsState: boolean
}

export const useGetJobAdsState = (ids: string[]): JobAdsStateFetch => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  const {
    data: jobAdsState,
    isPending: isLoadingJobAdsState,
    isSuccess: isSuccessJobAdsState,
    isError: isErrorJobAdsState,
  } = useQuery({
    enabled: isLogged,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getJobAdsState(ids),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [JOB_ADS_STATE_QUERY_KEY, ids.sort()],
    staleTime: QUERY_STALE_TIME,
  })
  return {
    isErrorJobAdsState,
    isLoadingJobAdsState,
    isSuccessJobAdsState,
    jobAdsState,
  }
}
